<template>
  <div class="d-flex align-items-center justify-content-center vh-100 px-3">
    <b-card class="p-3 w-100" style="max-width: 400px; border-radius: 20px; border: 1px solid lightgrey;">
      <div class="text-center">
        <b-link :to="{ name: 'Login' }">
          <img :src="this.appLogoImage" class="img-fluid" width="150" />
        </b-link>
      </div>

      <b-card-title title-tag="h2" class="font-weight-bold text-dark text-center mt-3">
        Set new password
      </b-card-title>

      <b-card-text class="text-muted text-center" style="font-size: 0.9rem">
        Please enter and re-enter your new password
      </b-card-text>

      <validation-observer ref="loginFormValidation">
        <b-form class="mt-3" @submit.prevent="validateForm">
          <b-form-group label-for="password">
            <validation-provider #default="{ errors }" name="New Password" rules="required">
              <b-input-group :class="errors.length > 0 ? 'is-invalid' : null">
                <b-form-input
                  id="password"
                  v-model="password"
                  :state="errors.length > 0 ? false : null"
                  class="form-control"
                  :type="passwordFieldType"
                  placeholder="New Password"
                />
                <b-input-group-append is-text>
                  <feather-icon class="cursor-pointer" :icon="passwordToggleIcon" @click="togglePasswordVisibility" />
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group label-for="reEnterPassword" class="mt-2">
            <validation-provider #default="{ errors }" name="Re Enter Password" rules="required">
              <b-input-group :class="errors.length > 0 ? 'is-invalid' : null">
                <b-form-input
                  id="reEnterPassword"
                  v-model="reEnterPassword"
                  :state="errors.length > 0 ? false : null"
                  class="form-control"
                  :type="passwordFieldType"
                  placeholder="Re Enter Password"
                />
                <b-input-group-append is-text>
                  <feather-icon class="cursor-pointer" :icon="passwordToggleIcon" @click="togglePasswordVisibility" />
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-button class="mt-3" type="submit" variant="primary" block>
            Change Password
          </b-button>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import { $themeConfig } from "@themeConfig";
import { mapActions, mapGetters } from "vuex";
import util from "@/util.js";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  props: {
    email: {
      type: String,
      required: true,
    },
    verification_code: {
      type: String,
      required: true,
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility, util],
  data() {
    return {
      appName: "",
      appFullName: "",
      appFullName: "",
      password: "",
      reEnterPassword: "",
      required,
    };
  },
  created() {
    this.appName = $themeConfig.app.appName;
    this.appFullName = $themeConfig.app.appFullName;
    this.appLogoImage = $themeConfig.app.appLogoImage;
  },
  methods: {
    ...mapActions({ confirmReset: "appData/confirmReset" }),
    async validateForm() {
      const success = await this.$refs.loginFormValidation.validate();
      if (success) {
        await this.submit();
      }
    },
    async submit() {
      try{
        const res = await this.confirmReset({
        payload: {
            "email": this.email,
            "code": this.verification_code,
            "new_password": this.password,
            "confirm_new_password": this.reEnterPassword,
          }
        }
      );
      console.log("COnfirm Reset: ", res);
      if (res.status === 200) {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "Password Reset Successfully",
              variant: "success",
              icon: "BellIcon",
            },
          },
          {
            position: "top-right",
          }
        );
        this.$router.push({ name: "Login" });      
      }
      } catch (error) {        
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "Password Must be 8 Character Long, Shouldn't be too common.", 
              variant: "danger",
              icon: "BellIcon",
            },
          },
          {
            position: "top-right",
          }
        );
      }
    },
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    ...mapGetters({ hasRole: "appData/hasRole" }),
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>

<style scoped>
/* Ensure it looks good on smaller screens */
@media (max-width: 576px) {
  .vh-100 {
    height: auto !important;
    min-height: 100vh;
  }
}
</style>
